import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import ServiceNavbar from "../cpa/components/ServiceNavbar";

function Cpe() {
  return (
    <>
      {/* banner */}
      <div className="banner">
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.4, default: { ease: "linear" } }}
        >
          <img src="/cpaImg/CPA.jpg" alt="CPA Banner" loading="lazy" />
        </motion.div>

        <div className="cpabannertext dis">
          Becker
          <br />
          CPE
          <br />
          <div className="fs-1 dis">foundational</div>
        </div>
      </div>

      {/* Service Nav */}
      <ServiceNavbar />
      {/* USCPA 有助生涯&職涯規劃 */}
      <div className="container mb100 mt100">
          <img
            alt=""
            className="img_center w-100"
            src="/user_upload/art/05/46/546_photo_15754.png"
          />
        <p>
          給全球美國註冊會計師的好消息！捷進顧問 (Becker Professional
          Education 在台總代理) 即日起以優惠價格販售美國證照進修課程方案{" "}
          <a
            href="https://www.becker.com/cpe/catalog/select?v=6711"
            target="_blank"
            rel="noopener noreferrer"
          >
            Becker Select – CPE Course Package
          </a>
          。
        </p>

        <ul>
          <li>
            <strong>使用效期與內容</strong>
            ：一年內可任選參加 Becker CPE 系列中所有 foundational,
            state- and industry-specific 類型課程，詳細內容依
            <a
              href="https://www.becker.com/cpe/catalog/select?v=6711"
              target="_blank"
              rel="noopener noreferrer"
            >
              方案原文頁面
            </a>
            顯示為準 (內含課程目錄)。
          </li>
          <li>
            <strong>台灣售價</strong>：新台幣 9,500 元（美國 Becker 原價
            US$499.00，約新台幣 14,500 元）
          </li>
        </ul>

        <hr />
        <p>
          <span>
            <strong>甚麼是 CPE？</strong>
          </span>
        </p>

        <p>
          Continuing Professional Education (簡稱 CPE)
          是通過美國註冊會計師考試、並取得第一張執業執照 (active license)
          後，依各州會計師法規定逐年必修的進修課程，學習範圍包括財務會計、審計、稅務、道德倫理、資訊系統、管理顧問、商業溝通等會計行業實務上所需的各類硬實力、軟實力，課程隨著產業變動頻繁更新。
        </p>

        <p>
          美國管理會計師 (CMA)、美國註冊稅務師 (EA)
          也要求持照者每年累積一定數量的 CPE。
        </p>

        <p>
          Becker 所製作與販售的 CPE 課程為美國註冊會計師協會認可
          (AICPA-approved CPE courses)
          的全線上學習課程，近期熱門課程有各州指定道德倫理 (ethics)、Microsoft
          Excel 技能、年度審計準則更新 (GAAS update)、各類稅法更新、資料視覺化
          (data visualization) 等。
        </p>

        <hr />
        <p>
          <span>
            <strong>誰需要 CPE？</strong>
          </span>
        </p>

        <ol>
          <li>
            <strong>第一種類型：已取得專業美國證照者</strong>
            <ul>
              <li>
                <strong>美國註冊會計師 (CPA)</strong>
                <br />
                已經持有美國註冊會計師執業型執照 (active license)，且欲持續延長
                (renew)
                會籍和執照效力者，需要修習累積&nbsp;CPE 學分。若無累積所屬州別規定的
                CPE 學分數量，則無法獲發下一張執照，原執照到期即失效，轉為無效狀態
                (deliquent) 並依法不可繼續自稱為美國註冊會計師。
                <p>
                  常見規定為每 3 年至少修得 120 個 CPE 學分；其中，每 1 年最少修得 20
                  學分（依各州州法規定不同）。
                </p>
              </li>
              <li>
                <p>
                  <strong>美國管理會計師 (CMA)</strong>
                  <br />
                  持照者每年須累積 30 個 CPE 學分，方可延續資格與頭銜。
                </p>
              </li>
              <li>
                <strong>美國註冊稅務師 (EA)</strong>
                <br />
                持照者每年須累積至少 16&nbsp;個 CPE 學分（每 3 年需累積 72
                學分），方可延續資格與頭銜。
                <br />
                &nbsp;
              </li>
            </ul>
          </li>
          <li>
            <strong>第二種類型：自我成長型財會人才</strong>
            <br />
            雖無須維持美國註冊會計師執照效力，但欲持續精進美國商業環境相關知識者。
          </li>
        </ol>

        <hr />
        <p>
          <span>
            <strong>大學、研究所學分，可以抵 CPE 嗎？</strong>
          </span>
        </p>

        <p>
          不行。CPE
          是針對美國財務會計、審計、稅務、道德倫理、資訊系統、商業溝通等會計行業實務所需的硬實力、軟實力，所設計的進修課程。學習模式與會計師事務所內部訓練類似，學習分量與所花時間比學校學分課少，學習內容偏實務應用，且頻繁根據法令頒布而更新。
        </p>

        <hr />
        <p>
          <span>
            <strong>Becker 提供的 CPE 課程有哪些優勢？</strong>
          </span>
        </p>

        <ul>
          <li>
            <strong>課程內容與產業高度連結 ⸺</strong>
            <br />
            Becker CPE
            線上課程設計，旨在幫助當今的會計專業人才持續跟上業界動態。Becker CPE
            課程及時更新、內容準確，深入研究最新趨勢，包括財務會計與審計 (A&amp;A)
            準則更新、各州和聯邦稅收、營業稅務相關問題，也針對最新的 GASB 和PCAOB
            準則、黃皮書、商業倫理等進行深入探討。
          </li>
          <li>
            <strong>實際經驗。現實應用 ⸺</strong>
            <br />
            Becker&nbsp;CPE
            教學團隊擁有幾十年的實務經驗，執業背景含括會計事務所到企業財會、到管理顧問和學術教育等各領域，依此設計實務舉例、清楚解說概念的
            CPE 進修課程。講師群擁有會計、財務、稅收、數據分析等專業背景，以提供最全面的學習體驗。
          </li>
          <li>
            <strong>會計專業人士信賴品牌 ⸺</strong>
            <br />
            Becker 長期為 CPA 考生、和追求持續精進的執業會計師，提供無可比擬的輔考產品。因此，超過2,900家頂尖會計事務所、公司、企業聯盟、政府機構和大學選擇與
            Becker 合作，協力提供 CPA 和 CPE 課程。
          </li>
        </ul>

        <hr />
        <p>
          <span>
            <strong>Becker 的 CPE Select 年度訂閱方案介紹</strong>
          </span>
        </p>

        <p>
          <strong>全年無限學習，彈性自主</strong>
        </p>

        <p>
          訂閱 Select 方案後，即可於一年內不限次數使用 Becker 的直播課程（Webcast）與隨選課程（On
          Demand），讓您依照個人工作與生活節奏、自由安排進修時間表。
        </p>

        <p>
          <strong>專為實務打造的課程內容</strong>
        </p>

        <ul>
          <li>涵蓋會計、審計、稅務、管理顧問等 NASBA 核心專業</li>
          <li>
            提供絕大多數州別（含哥倫比亞特區、波多黎各與關島）的
            <strong>該州規定必修</strong>會計道德課程
          </li>
          <li>
            精選兩門 8 小時的進階課程，深入探討關鍵議題，例如稅務法規更新、會計準則變動或
            COVID-19 相關立法*
          </li>
        </ul>

        <p>
          <strong>優化學習體驗</strong>
        </p>

        <ul>
          <li>課程皆包含講師影音教學，提升理解與吸收效率，不再只依賴 PDF 閱讀資料</li>
          <li>完成課程後，即可立即下載 CPE 完課證書，快速取得學分**</li>
        </ul>

        <p>
          Becker CPE Select 是 CPA、CMA
          及其他財會專業人士的進修首選，協助您持續精進專業能力，強化實務表現。
        </p>

        <p>
          <strong>查看完整課程清單：</strong>
          <br />
          <a
            href="https://www.becker.com/cpe/catalog?search_api_fulltext=&f%5B0%5D=cpe_product_subscription%3ASelect"
            target="_blank"
            rel="noopener noreferrer"
          >
            Becker CPE Select 課程總覽目錄
          </a>
        </p>

        <p>
          <span>
            <span style={{ color: "#7f8c8d" }}>
              *Premium 課程主題與安排每年持續更新，依美國&nbsp;Becker
              官方公告為準
              <br />
              **CPE 證書發放條件須依 Becker 系統規範完成課程
            </span>
          </span>
        </p>

        <hr />
        <p>
          <Link className="" to={`/registration?parent_id=4`}
          >
           立即購買 Becker CPE Select 方案
          </Link>
        </p>
      </div>
    </>
  );
}

export default Cpe;
